import { useMemo, useRef, useState } from 'react'
import ReportsPagesContent from 'src/component/ReportsPagesContent'
import { GetMedicineChangeRequests } from 'src/requests/DoctorRequest'
import SearchWrapper from 'src/component/searchSection'
import { Original } from 'src/common/Common.Type'
import MedicinesPopup from './MedicinesPopup'
import { dateFormatter } from 'src/utils'
import BaseBtn from 'src/component/ActionBtn/BaseBtn'
import { useLocation } from 'react-router-dom'

const ChangeRequest = () => {

  const [recordID, setRecordID] = useState<number | null>(null)
  const [hospitalID, setHospitalID] = useState<number | null>(null)
  const { state } = useLocation()

  const modelpopup = useRef<any>("")

  const columns = useMemo(() => [
    {
      Header: "requestId",
      accessor: "id",
    },
    {
      Header: "patientName",
      accessor: "patientName",
      canSearch: true
    },
    {
      Header: "phoneNumber",
      accessor: "phoneNumber",
    },
    {
      Header: "nationalId",
      accessor: "patientNationalId",
    },
    {
      Header: "hospitalName",
      accessor: "hospitalName",
    },
    {
      Header: "diagnosis",
      accessor: "diagnosis",
    },
    {
      Header: "status",
      accessor: "status",
    },
    {
      Header: "serviceType",
      accessor: "serviceType",
    },
    {
      Header: "requestDueDate",
      Cell: ({ row: { original } }: Original) => (dateFormatter(original.requestDueDate, "ar"))
    },
    {
      Header: "requestCreatedDate",
      accessor: "requestCreatedDate",
      canSearch: true,
      visible: false,
      type: "Date",
      isMulti: true,
    },
    {
      Header: "lastDeliveryDate",
      Cell: ({ row: { original } }: Original) => (dateFormatter(original.lastDeliveryDate, "ar")),
    },
    {
      Header: "actions",
      Cell: ({ row: { original } }: any) => {
        return (
          <BaseBtn
            label="changeMedicinesRequest"
            icon={"ic:sharp-change-circle"}
            className='update'
            ApplyAction={() => openMedicinesPopup(original.id, original.hospitalId)}
            isVisible={!original?.isPendingRequest}
          />
        )
      }
    }


  ], [state])

  const openMedicinesPopup = (id: number, hopsitalId: number) => {
    // if (!checkIfSelectedPharmacy(state)) return errorToaster("please-select-hosptial")
    setRecordID(id)
    setHospitalID(hopsitalId)
    modelpopup.current.click()
  }

  return (

    <>
      <MedicinesPopup hospitalId={hospitalID} recordID={recordID} modalID={modelpopup} />
      <ReportsPagesContent tableAPI={GetMedicineChangeRequests} columns={columns} >
        <SearchWrapper />
      </ReportsPagesContent>
    </>
  )
}

export default ChangeRequest